<script>
	export let fld;
	export let docId;

	$: suggestions =
		typeof fld.suggestion === "function"
			? fld.suggestion(docId)
			: (Array.isArray(fld.suggestion)
					? fld.suggestion
					: [fld.suggestion]
				).filter(Boolean);
</script>

{#each suggestions as suggestion}
	{#if Array.isArray(suggestion.label)}
		{#each suggestion.label as label, index}
			{#if typeof suggestion.function?.[index] === "function"}
				<button
					{docId}
					on:click|preventDefault|stopPropagation={suggestion
						.function[index]}
					class={"link text-left text-info hover:cursor-pointer hover-ripple my-2 sm:my-4"}
					>{@html label(docId)}</button
				>
			{:else}
				<div class="text-left my-2 sm:my-4 hover:cursor-auto">
					{@html label(docId)}
				</div>
			{/if}
		{/each}
	{:else if typeof suggestion.function === "function"}
		<button
			{docId}
			on:click|preventDefault|stopPropagation={suggestion.function}
			class={"link text-left text-info hover:cursor-pointer hover-ripple my-2 sm:my-4"}
			>{@html suggestion.label(docId)}</button
		>
	{:else}
		<div class="text-left my-2 sm:my-4 hover:cursor-auto">
			{@html suggestion.label(docId)}
		</div>
	{/if}
{/each}
